import type { Texture, Sprite, Graphics, Container } from "pixi.js";

import type { Filter } from "pixi.js";

import type { ITypeMedia } from "../../../interfaces/Artists";

interface IPosition {
  destination: {
    x: number;

    y: number;

    width: number;

    height: number;
  };

  source: {
    x: number;

    y: number;

    width: number;

    height: number;
  };
}

interface IElement {
  element: HTMLVideoElement | HTMLImageElement | HTMLCanvasElement;

  type: ITypeMedia;
}

class DrawCache {
  Texture: { [key: string]: Texture } = {};

  Sprites: { [key: string]: Sprite } = {};

  Elements: { [key: string]: IElement } = {};

  positions: { [key: string]: IPosition } = {};

  Containers: { [key: string]: Container } = {};

  Masks: { [key: string]: Graphics } = {};

  LastTimeline: { [key: string]: number } = {};

  Filters: { [key: string]: Filter[] } = {};

  FilterSignatures: { [key: string]: string } = {};

  // Firma del layout+fuente del área: si no cambió, se reusan sprite/máscara/container cacheados

  // en vez de recrearlos cada frame (solo se refrescan las texturas dinámicas). Ver RenderFactory.

  AreaSignatures: { [key: string]: string } = {};

  constructor() {
    this.Texture = {};

    this.Sprites = {};

    this.Elements = {};

    this.positions = {};

    this.Containers = {};

    this.Masks = {};

    this.LastTimeline = {};

    this.Filters = {};

    this.FilterSignatures = {};

    this.AreaSignatures = {};
  }
}

export default DrawCache;
